export default __webpack_public_path__ + "static/media/home-img-4.74d35607.png";